// extracted by mini-css-extract-plugin
export var section = "Curious-module--section--Cm+Sr";